export enum Regions {
  OTHER = 'OTHER',
  CALIFORNIA = 'CA',
}
